import { ContractAmendmentSummary } from '@kalos/kalos-rpc';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../../../hooks/react-query/constants';
import { MembershipClientService } from '../../../tools/helpers';

const keys = queryKeys.memberships;

const STALE_MS = 60 * 1000;

const isOpen = (a: ContractAmendmentSummary) => a.needsReview === 1 || a.pendingPayment === 1;

/** A contract's amendments, open ones (awaiting review or payment) first. */
export const useContractAmendmentsQuery = (contractId: number, enabled = true) => {
  const req = ContractAmendmentSummary.create({
    contractId,
    withoutLimit: true,
    orderBy: 'date_created',
    orderDir: 'desc',
  });
  return useQuery({
    queryKey: [keys.root, keys.amendments, keys.getHash({ ...req })],
    queryFn: () => MembershipClientService.BatchGetContractAmendmentSummary(req),
    enabled: enabled && contractId > 0,
    staleTime: STALE_MS,
    select: (list) => [...list.results].sort((a, b) => Number(isOpen(b)) - Number(isOpen(a))),
  });
};

/** One amendment's summary by id; null when there is none. */
export const useContractAmendmentQuery = (id: number, enabled = true) => {
  const req = ContractAmendmentSummary.create({ contractAmendmentId: id });
  return useQuery({
    queryKey: [keys.root, keys.amendments, keys.getHash({ ...req })],
    queryFn: () => MembershipClientService.BatchGetContractAmendmentSummary(req),
    enabled: enabled && id > 0,
    staleTime: STALE_MS,
    select: (list) => list.results[0] ?? null,
  });
};
